import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { fetchPosts } from "./api";
import { fetchTag, fetchSOLR } from "./api";

/* global options */

const useStyles = makeStyles({
	catHead: {
		width: "100%",
		height: "304px",
		margin: "auto",
		position: "relative",
		"@media (max-width: 959px)": {
			height: "204px",
		},
	},
	background: {
		height: "100%",
		position: "absolute",
		top: "0",
		left: "0",
		right: "0",
		overflow: "hidden",
	},
	bgLayerBanner: {
		height: "304px",
		width: "100%",
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		backgroundPosition: "center right",
		top: "0",
		right: "0",
		position: "absolute",
		"@media (max-width: 959px)": {
			height: "204px",
		},
	},
	svg: {
		position: "absolute",
		left: "0",
		top: "0",
		height: "100%",
		fill: "white",
		"@media (max-width: 959px)": {
			transform: "translateX(-40%)"
		},
	},
	catHeadContent: {
		maxWidth: "40vw",
		width: "100%",
		margin: "auto",
		padding: "24px",
		display: "flex",
		height: "256px",
		zIndex: "1",
		position: "absolute",
		"@media (max-width: 959px)": {
			height: "204px",
		},
	},
	catDetails: {
		marginLeft: "2em",
		fontFamily: "Lato,Helvetica Neue,Open Sans,Helvetica,Arial,sans-serif",
		color: "#333",
		"@media (max-width: 959px)": {
			marginLeft: "0em",
		},
	},
	description: {
		maxHeight: "103px",
		overflow: "hidden",
		marginLeft: "1em",
		color: "#333",
		"@media (max-width: 959px)": {
			display:"none"
		},
		fontSize:"1.1em"
	},
	title: {
		color: "var(--main-color)",
		position: "relative",
		left: "0",
		top: "0",
		fontSize: "100px",
	},
	content: {
		marginTop: "2em",
		columnGap: "1em",
		flex: 1
	},
	subContent: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-start",
		columnGap: "1em",
		rowGap: "1em"
	},
	post: {
		color: "#333",
		overflow: "hidden",
		background: "linear-gradient(125deg, rgb(243, 246, 248), rgb(243, 246, 248) 63.5%, rgb(234, 239, 242) 36.5%)",
		borderRadius: "0px",
		display: "flex",
		flexDirection: "column",
		"@media (min-width: 959px)": {
			width: "calc(50% - 1em)",
		},
		"@media (min-width: 1300px)": {
			width: "calc(33% - 1em)",
		},
		"@media (min-width: 1700px)": {
			width: "calc(25% - 1em)",
		},
		"& > .post-data": {
			padding: "0.5em",
			position: "relative"
		},
		"& h2": {
			color: "var(--main-color)",
			marginTop: 50,
			height: "unset"
		}
	},
	postImage: {
		width: "100%",
		borderRadius: "0",
		height: "175px",
		overflow: "hidden",
	},
	sidebar: {
		width: "200px",
		display: "flex",
		flexDirection: "column",
		rowGap: "0.5em",
		marginTop: "2em",
		"& > *": {
			margin: "0 26px",
			color: "var(--main-color)",
			fontSize: 16
		},
		"& > .active": {
			color: "var(--main-color-dark)",
			fontWeight: 600
		},
		"& > h2": {
			fontSize: 26,
			color: "#333",
		},
		"@media (max-width: 959px)": {
			display:"none",
		},
	},
	contentWrapper: {
		display: "flex",
		marginTop: "1em",
		marginBottom: "2em",
		backgroundColor: "white",
		"@media (max-width: 959px)": {
			padding: "1em",
		},
	},
	subTitle: {
		color: "#333",
		fontSize: 32
	},
	tag: {
		position: "absolute",
		left: "0",
		top: "0",
		padding: "5px 10px",
		backgroundColor: "var(--main-color)",
		color: "white",
		fontWeight: "700",
		minWidth: "80px",
		textAlign: "center",
		fontSize: "15px"
	}
});
const imageCDN = "https://i2.wp.com/wikannabis.com/wp-content/uploads/sites/2/"

const OriginalBlog = () => {
	const classes = useStyles();
	const [blogs, setBlogs] = useState(null);
	const [tags, setTags] = useState(null);
	const [category, setCategory] = useState(null);

	useEffect(() => {
		loadPosts();
		loadTags();
	}, []);

	const loadPosts = async () => {
		const newBlogs = await fetchSOLR("", 'blog', "blogDefault", [{ key: 'per_page', value: 10 }]);
		console.log({newBlogs})
		setBlogs(newBlogs.docs);
	};

	const loadTags = async () => {
		setTags(await fetchTag());
	};

	const genPost = (post) => {
		if (post) {
			return (
				<div className={classes.post}>
					<div className={classes.postImage}>
						<a href={post.permalink}>
							<img src={imageCDN+post.imageSrc+"?w=600&h=500&ssl=1"} />
						</a>
					</div>
					<div className="post-data">
						{post.taxonomy.length > 0 ? <div className={classes.tag}>{post.taxonomy[0]}</div> : ""}
						<a href={post.permalink}>
							<h2>{post.postTitle}</h2>
						</a>
						<span className="post-desc" dangerouslySetInnerHTML={{ __html: post.meta_description }}></span>
					</div>
				</div>
			);
		}
	};

	const genContent = () => {
		if (blogs != null) {
			return (blogs.map(blog => genPost(blog)));
		}
	};

	const genTags = () => {
		if (tags != null) {
			return (tags.map((tags, index) => {
				return (
					<a key={index} href={`?categorie=${tags.name}`}>{tags.name}</a>
				);
			}));
		}
	};

	if (blogs == null) return (<></>);
	return (
		<div style={{background: "#EBEDED"}}>
			<div className={classes.catHead}>
				<div className={classes.background}>
					<div className={classes.bgLayerBanner} style={{ backgroundImage: `url(${options.banner.url})` }}></div>
					<svg className={classes.svg} viewBox="0 0 1439 304" preserveAspectRatio="xMinYMid slice">
						<path opacity="0.5" d="M 0,304 V 0 H 963 L 1439,304 Z" className="style-scope ytd-interactive-tabbed-header-renderer"></path>
						<path opacity="0.5" d="M 0,0 l 0,304 580,0 L 1055,0 0,0 Z" className="style-scope ytd-interactive-tabbed-header-renderer"></path>
						<path opacity="0.9" d="M 0,304 V 0 H 780 L 1247,304 Z" className="style-scope ytd-interactive-tabbed-header-renderer"></path>
					</svg>
				</div>
				<div className={classes.catHeadContent}>
					<div className={classes.catDetails}>
						<h1 className={classes.title}>{options.title}</h1>
						<div className={classes.description}>
							Wikannabis est le meilleur endroit pour trouver des articles, des recettes et les dernières nouvelles sur le cannabis - CBD. Nous avons tout ce que vous devez savoir sur cette plante étonnante !
						</div>
					</div>
				</div>
			</div>
			<div className={classes.contentWrapper}>
				<div className={classes.sidebar}>
					<h2>Catégories</h2>
					<a key="all" href="/" className={category == null ? "active" : ""}>Tout</a>
					{genTags()}
				</div>
				<div className={classes.content}>
					<h2 className={classes.subTitle}>Nos derniers articles</h2>
					<div className={classes.subContent}>
						{genContent()}
					</div>
				</div>
			</div>
		</div>
	);
};

export default OriginalBlog;